<template>
  <v-btn
    class="mb-2 text-white saveSearchResults font-12"
    color="accent2"
    size="small"
    @click="!user().isLoggedIn ? goToLogin() : saveSearchResults()"
  >
    Save Search Results
  </v-btn>
</template>

<script>
import { mapState } from "vuex";

// import saveSearch from "@/store";

export default {
  name: "SaveSearchButton",

  computed: {
    ...mapState("users", ["user"]),
  },

  methods: {
    /**
     * Save the advancedSearch Results
     */
    async saveSearchResults() {
      this.$store.commit("saveSearch/setSaveSearchStepperDialog", true);
    },
    /**
     * Goto To login page if user is not loggedIn
     */
    async goToLogin() {
      if (this.$route.path !== "/accounts/login") {
        await this.$router.push({
          path: "/accounts/login",
          query: {
            goTo: this.$route.fullPath,
          },
        });
      }
    },
  },
};
</script>
